<h2 id="assignment-phase-heading" lvrPadding [padHorizontal]="32" [padVertical]="0">
	{{ 'assignment.phase.title_' + phaseTransitionType() | transloco }}
</h2>

<div style="margin-bottom: 16px">
	<p style="max-width: 600px">
		{{ 'assignment.phase.' + phaseTransitionType() + '_info' | transloco }}
	</p>
</div>

@if (!isPhase4Transition()) {
	<lvr-assignment-details
		[assignment]="assignment()!"
		[clientId]="+clientId()"
		[initiators]="initiators()"
	></lvr-assignment-details>
}

<lvr-assignment-links
	[clientId]="clientId()"
	[assignmentId]="assignment()!.id"
	[redirectUrl]="currentUrl"
	[reportId]="targetPhase() === DB_PHASES.P4 ? endReport()?.id : startReport()?.id"
	[targetPhase]="targetPhase()"
></lvr-assignment-links>

<lvr-assignment-checks
	[errors]="validationData()!"
	[assignmentId]="assignment()!.id"
	[clientId]="clientId()"
	[institutionId]="currentInstitutionId()"
	[mainInstitutionId]="mainInstitutionId()"
	[isMainInstitution]="isCurrentInstitutionMain()"
	[careerId]="currentCareerId()"
	[reportId]="targetPhase() === DB_PHASES.P4 ? endReport()?.id : startReport()?.id"
	[disabilityReportId]="disabilityReport()?.id"
	[targetPhase]="targetPhase()"
></lvr-assignment-checks>

<lvr-default-actions
	[showLoading]="saving()"
	[labelSave]="saveButtonKey()"
	(save)="save()"
	[disableSave]="disableContinueButton()"
	(cancelSave)="cancel()"
></lvr-default-actions>
